const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let scriptPromise = null;

function loadScript() {
	if (window.grecaptcha) return Promise.resolve();

	if (!scriptPromise) {
		scriptPromise = new Promise((resolve, reject) => {
			const script = document.createElement("script");
			script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
			script.async = true;
			script.onload = () => resolve();
			script.onerror = () => reject(new Error("Failed to load reCAPTCHA"));
			document.head.appendChild(script);
		});
	}

	return scriptPromise;
}

export default function useRecaptcha() {
	const getToken = async (action) => {
		if (!SITE_KEY) {
			throw new Error("reCAPTCHA site key is not configured");
		}

		await loadScript();

		return new Promise((resolve, reject) => {
			window.grecaptcha.ready(() => {
				window.grecaptcha
					.execute(SITE_KEY, { action })
					.then(resolve)
					.catch(reject);
			});
		});
	};

	return { getToken };
}
